import { css } from 'lit';

export const styles = css`
  :host {
    --column-gap: calc(15rem / var(--default-rem-px-count));
  }

  :host(:not(:last-child)) > .expanded {
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  .barrel-wrapper {
    height: calc(60rem / var(--default-rem-px-count));
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .expanded {
    height: unset;
  }

  .hide {
    display: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60rem / var(--default-rem-px-count));
    border-top: 2px solid #222222;
    cursor: pointer;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-size: calc(16rem / var(--default-rem-px-count));
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  .hardware-options-wrapper,
  .pattern-options-wrapper {
    width: 100%;
    padding-top: calc(16rem / var(--default-rem-px-count));
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    margin-bottom: calc(20rem / var(--default-rem-px-count));
    border-bottom: 1px solid var(--block-rule-color, #c0c0c0);
  }

  .pattern-options-wrapper:last-child {
    border-bottom: none;
  }

  .swatch-group {
    padding-bottom: calc(14rem / var(--default-rem-px-count));
  }

  p.swatch-group-header {
    font-size: calc(14rem / var(--default-rem-px-count));
    font-style: normal;
    font-weight: 500;
    line-height: calc(14rem / var(--default-rem-px-count));
    letter-spacing: -0.18px;
    padding: calc(8rem / var(--default-rem-px-count)) 0;
  }

  .swatches {
    max-width: 100%;
    display: inline-grid;
    gap: calc(5rem / var(--default-rem-px-count));
    grid-template-columns: repeat(
      5,
      minmax(0, calc(100rem / var(--default-rem-px-count)))
    );
  }

  .needs-border {
    border: 0.5px solid var(--block-rule-color, #c0c0c0);
  }

  .material-swatches {
    max-width: 100%;
    display: inline-grid;
    gap: calc(5rem / var(--default-rem-px-count));
    grid-template-columns: repeat(
      3,
      minmax(0, calc(100rem / var(--default-rem-px-count)))
    );
  }

  .hardware-options-header,
  .pattern-options-header {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  .swatch-wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  .swatch-wrapper span {
    display: flex;
  }

  .color-swatch span {
    width: 100%;
    display: block;
    aspect-ratio: 4 / 5;
  }

  .image-swatch img {
    width: 100%;
    height: 100%;
  }

  .swatch-name {
    font-size: calc(12rem / var(--default-rem-px-count));
    letter-spacing: -0.15px;
    padding-top: 2px;
    padding-left: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
    line-height: 1.3em;
    max-height: calc(14rem / var(--default-rem-px-count));
  }

  .selected-swatch {
    padding: var(--selected-variant-padding-width);
    border: var(--selected-variant-border-width) solid #222222;
  }

  .not-selected-swatch {
    padding: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
  }

  .swatch-controls {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: calc(20rem / var(--default-rem-px-count));
  }

  .swatch-page-controls {
    display: flex;
  }

  .swatch-page-controls span {
    cursor: pointer;
    width: calc(40rem / var(--default-rem-px-count));
    height: calc(40rem / var(--default-rem-px-count));
    display: flex;
    align-items: center;
  }

  .swatch-page-controls span {
    justify-content: center;
    margin: calc(5rem / var(--default-rem-px-count));
  }

  .swatch-page-controls:hover span {
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .swatch-page-controls span svg {
    width: 45%;
    height: 45%;
  }

  .no-results {
    height: calc(100rem / var(--default-rem-px-count));
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-arrow {
    transform: rotate(180deg);
  }

  cta-button {
    margin-top: calc(30rem / var(--default-rem-px-count));
    display: block;
    width: calc(50% - var(--column-gap));
  }

  .pattern-filters {
    display: flex;
    flex-direction: column;
    column-gap: var(--column-gap);
  }

  .input-wrapper {
    flex-grow: 1;
    position: relative;
    display: flex;
  }

  .input-wrapper.search {
    border: 1px solid #222222;
  }

  .search input {
    width: 100%;
  }

  /* Override browser defaults */
  input {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
    background: none;
  }

  input {
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-left: calc(16rem / var(--default-rem-px-count));
    display: block;
  }

  .search-icon {
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-right: calc(16rem / var(--default-rem-px-count));
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto;
  }

  @media (min-width: 600px) {
    .swatches {
      gap: calc(10rem / var(--default-rem-px-count));
      grid-template-columns: repeat(
        6,
        minmax(0, calc(100rem / var(--default-rem-px-count)))
      );
    }

    .material-swatches {
      gap: calc(10rem / var(--default-rem-px-count));
      grid-template-columns: repeat(
        5,
        minmax(0, calc(100rem / var(--default-rem-px-count)))
      );
    }
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }
  }
`;
